module.exports = __webpack_public_path__ + "img/ic_launcher_final_foreground.099bf079.png";